/**
 * Build süreci için localStorage polyfill
 * Node.js ortamında localStorage mevcut olmadığında mock localStorage sağlar
 */

// Node.js ortamında localStorage yoksa mock localStorage oluştur
if (typeof window === 'undefined') {
    const mockStorage = {
        data: {},
        getItem(key) {
            return this.data[key] || null;
        },
        setItem(key, value) {
            this.data[key] = value;
        },
        removeItem(key) {
            delete this.data[key];
        },
        clear() {
            this.data = {};
        },
        get length() {
            return Object.keys(this.data).length;
        },
        key(index) {
            const keys = Object.keys(this.data);
            return keys[index] || null;
        }
    };

    // Global localStorage mock'unu tanımla
    global.localStorage = mockStorage;
    global.sessionStorage = mockStorage;
    
    // window object'i yoksa mock window oluştur
    global.window = {
        localStorage: mockStorage,
        sessionStorage: mockStorage,
        location: {
            reload: () => {}
        }
    };
}